import { AppButton } from '../button'
import { useStyles } from './styles'
import { lang } from '@/shared/constants/lang'
import { useUnit } from 'effector-react'
import { $userLanguage } from '@/entities/user'
import { Icon } from '../icon'
import { useCallback, useState } from 'react'

type CaseOpeningConfirmationProps = {
  requiredKeys: number
  onConfirm: () => void
  onDeny: () => void
  caseName: string
}

export const CaseOpeningConfirmation = (props: CaseOpeningConfirmationProps) => {
  const userLang = useUnit($userLanguage)
  const { classes } = useStyles()
  const { requiredKeys, onConfirm, onDeny, caseName } = props
  const btnTexts = lang[userLang].pages.btnTexts
  const [locked, setLocked] = useState<boolean>(false)

  const handleConfirm = useCallback(() => {
    onConfirm()
    setLocked(true)
  }, [onConfirm])

  return (
    <div className={classes.root}>
      <span className={classes.modalText}>
        {btnTexts.open} {caseName}?
      </span>
      <div className={classes.buttonWrapper}>
        <AppButton
          variant="secondary"
          className={classes.backButton}
          onClick={onDeny}
        >
          {lang[userLang].pages.btnTexts.back}
        </AppButton>
        <AppButton
          variant="primary"
          disabled={locked}
          className={classes.useButton}
          onClick={handleConfirm}
        >
          {lang[userLang].pages.btnTexts.use} {requiredKeys}
          &nbsp;
          <Icon
            view="gamedKey"
            width={16}
          />
        </AppButton>
      </div>
    </div>
  )
}
